import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { manageUserStyles } from '../../Styles/adminStyles';
import { inject, observer } from 'mobx-react';
import { ReactSVG } from 'react-svg';
import Images from '../../Theme/Images';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import Header from '../../Common/Header'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Moment from 'moment';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import AddUser from './AddUser';
import Loader from 'react-loader-spinner';
import DeleteDialog from '../../Common/DeleteDialog';
import AdminChangePassword from './AdminChangePassword'
import Tooltip from '@material-ui/core/Tooltip';
import BlockDialog from './BlockDialog';
import { Scrollbars } from 'react-custom-scrollbars';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        boxShadow: theme.shadows[1],
        fontSize: '13px',
    },
}))(Tooltip);
@inject('userStore', 'adminStore', 'commonStore')
@observer
class ManageEnterprises extends Component {
    state = {
        pagination: {
            low: 0,
            high: 10,
            page: 0
        },
        noEntryMessage: 'No entries found! ',
        add: true,
        currentUser: {},
        deleteDialog: false
    }

    componentDidMount() {
        this.props.commonStore.setActiveTab('ent');
        this.props.adminStore.resetSearch()
        this.props.adminStore.getEnterpriseList()
    }

    handleCloseMenu = () => {
        this.props.adminStore.resetUserMenuArray()
    }

    confirmDelete = () => {
        this.props.adminStore.deleteUser(this.state.currentUser._id);
    }

    deleteUser = (user) => {
        this.setState({ currentUser: user, deleteDialog: true });
        this.handleCloseMenu()
    }

    cancelDelete = () => {
        this.setState({ deleteDialog: false })
    }

    sortList = (sortType, index, field) => {
        this.props.adminStore.sortEnterpriseList(field, sortType)
    }

    editUser = (user) => {
        this.setState({ add: false, currentUser: user })
        this.props.adminStore.openAddUserDialog(true)
        this.handleCloseMenu()

    }

    changePassword = (user) => {
        this.setState({ currentUser: user })
        this.props.adminStore.openChangePasswordDialog(true)
        this.handleCloseMenu()
    }

    renderMenu = (index, row) => {
        const { userMenuArray } = this.props.adminStore;
        const { classes } = this.props
        return (
            <React.Fragment>
                <MoreVertIcon className={row.userType !== "AGENT" ? classes.inactiveMore : classes.activeMore} onClick={(e) => this.props.adminStore.openUserMenu(e, index)} />
                <Menu
                    elevation={1}
                    id="simple-menu"
                    anchorEl={userMenuArray[index]}
                    keepMounted
                    open={Boolean(userMenuArray[index])}
                    onClose={(event) => { this.handleCloseMenu() }}
                    classes={{
                        list: classes.menuItems
                    }}
                >
                    <MenuItem onClick={(event) => this.editUser(row)} >Edit User</MenuItem>
                    <MenuItem onClick={(event) => this.deleteUser(row)}>Delete User</MenuItem>
                    <MenuItem onClick={(e) => this.changePassword(row)}>Change Password</MenuItem>
                </Menu>
            </React.Fragment>
        )
    }

    renderNotFoundMessage = (message) => {
        const { classes } = this.props;
        return (
            <div className={classes.noUserMessage}>
                <span style={{ display: 'table-cell', verticalAlign: 'middle' }} className={classes.docHeader}>{message}</span>
            </div>
        )
    }

    getPage = (type) => {
        const { pagination } = this.state;
        const { totalEnterprises } = this.props.adminStore;
        const { user } = this.props.userStore;
        if (type === 'prev' && pagination.page - 1 > -1) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low - 10,
                high: pagination.high - 10,
                page: pagination.page - 1
            });
            this.props.adminStore.setPageNumber(temp.page);
            this.props.adminStore.getEnterpriseList()
            this.setState({ pagination: temp })
        }
        else if (type === 'next' && !(Math.ceil(totalEnterprises / 10) * 10 == pagination.high)) {
            const temp = Object.assign({}, pagination, {
                low: pagination.low + 10,
                high: pagination.high + 10,
                page: pagination.page + 1
            });
            this.props.adminStore.setPageNumber(temp.page);
            this.props.adminStore.getEnterpriseList()
            this.setState({ pagination: temp })
        }


    }

    renderPagination = () => {
        const { pagination } = this.state;
        const { classes } = this.props;
        let temp = pagination.high;
        const { totalEnterprises } = this.props.adminStore;
        if (totalEnterprises <= temp)
            temp = totalEnterprises;
        return (
            <div className={classes.pagination}> {pagination.low + 1}-{temp} of {totalEnterprises}
                <ChevronLeftIcon className={classes.icons} onClick={(e) => this.getPage('prev')} />
                <ChevronRightIcon className={classes.icons} onClick={(e) => this.getPage('next')} />
            </div>
        )
    }

    renderTableHead = () => {
        const { entTableHeader } = this.props.adminStore;
        const { classes } = this.props;
        const { user } = this.props.userStore;
        return (
            <TableHead>
                {
                    entTableHeader.map((row, index) => (
                        (
                            <TableCell key={index} className={classes.tableHeader} style={{ width: row.width }} align="left">
                                <div style={{ display: 'flex' }}>
                                    {row.name}
                                    {row.allowSort ? (row.sort === 1 ?
                                        <ReactSVG className={classes.sortIcons} src={Images.sort} onClick={(e) => this.sortList(-1, index, row.type)} /> :
                                        <ReactSVG className={classes.sortIcons} src={Images.reverseSort} onClick={(e) => this.sortList(1, index, row.type)} />)

                                        : null}
                                </div>
                            </TableCell>

                        )))
                }
                <TableCell className={classes.tableHeader} style={{ width: '10vw' }} align="left">
                    {this.renderPagination()}
                </TableCell>

            </TableHead>

        )
    }

    renderUserName = (user) => {
        const { classes, theme } = this.props;
        return (
            <div className="colFlex">
                <div className="rowFlex">
                    {user.userFullName}
                    {
                        user.newEmail &&
                        <LightTooltip title={`Email verification pending for new email - ${user.newEmail}`} aria-label="add">
                            <ReactSVG className={classes.sortIcons} src={Images.error} />
                        </LightTooltip>

                    }
                </div>
                <div style={{ color: theme.palette.steelGray, fontSize: '13px' }}>{user.email}</div>
            </div>
        )

    }

    openBlockDialog = (user) => {
        this.setState({ currentUser: user });
        this.props.adminStore.openBlockDialog(true);
    }

    renderTableContent() {
        const { classes } = this.props;
        const { enterpriseList, pageNo } = this.props.adminStore;
        const { user } = this.props.userStore;
        return (
            <TableBody>
                {enterpriseList.map((row, index) => (
                    <TableRow key={row._id} className={classes.tableRow}>
                        <TableCell className={classes.tableData} align="left" >{row.name}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.totalUploads}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.EXPORTED}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.creditsAvailable}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.AGENT}</TableCell>
                        <TableCell className={classes.tableData} align="left">{row.ADMIN}</TableCell>
                        <TableCell className={classes.tableData} align="left">{Moment(row.createdAt).format('DD/MM/YYYY, h:mm a')}</TableCell>
                        {/*user.userType === 'SUPER_ADMIN' ? <TableCell style={{ cursor: 'pointer', textDecoration: 'underline' }} className={classes.tableData} align="left" onClick={(e) => this.openBlockDialog(row)}>{row.ip}</TableCell> : null*/}
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    renderUsersTable = () => {
        const { classes } = this.props;
        return (
            <TableContainer style={{ height: '90%', backgroundColor: this.props.theme.palette.dark, overflow: 'hidden' }} elevation={0} component={Paper}>
                <Scrollbars>
                    <Table className={classes.table} aria-label="simple table">
                        {this.renderTableHead()}
                        {this.renderTableContent()}

                    </Table>
                </Scrollbars>
            </TableContainer>
        )
    }

    addAgent = () => {
        this.setState({ add: true })
        this.props.adminStore.openAddUserDialog(true);

    }

    render() {
        const { classes, theme } = this.props;
        const { enterpriseList, inProgress } = this.props.adminStore;
        const { add, currentUser, deleteDialog } = this.state;

        return (
            <div style={{ height: '100%', overflow: 'hidden' }}>
                <div className={classes.outerContainer}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', flex: '2', marginRight: '1vw' }}>
                        <div><Typography className={classes.heading}>Manage Enterprises</Typography></div>
                    </div>
                    <Header searchType="enterprises"></Header>
                </div>
                {
                    inProgress ?
                        <div style={{ height: '100%' }}>
                            <div><Loader height={100} width={100} color={this.props.theme.palette.blue} className={classes.loading} timeout={100000} /></div>
                        </div> :
                        (enterpriseList && enterpriseList.length ?
                            this.renderUsersTable() :
                            this.renderNotFoundMessage(this.state.noEntryMessage))
                }

                <BlockDialog ip={currentUser.ip} type={currentUser.isIpBlocked ? 'unblock' : 'block'}></BlockDialog>
            </div>
        )
    }
}

ManageEnterprises.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(manageUserStyles, { withTheme: true })(withRouter(ManageEnterprises));
